import { css } from '@emotion/css'
import colors from '@styles/colors';
import { mobileOnly } from '@styles/breakpoints';

export default {
    container: css({
        display: 'flex',
        MsFlexWrap: 'wrap',
        flexWrap: 'wrap',
        WebkitBoxAlign: 'center',
        MsFlexAlign: 'center',
        alignItems: 'center',

        [mobileOnly]: {
            WebkitBoxPack: 'center',
            MsFlexPack: 'center',
            justifyContent: 'center',
        },

        '.ing-circle': {
            color: colors.BLUE,
            fontSize: 10,
            borderRadius: '100%',
            width: 35,
            height: 35,
            display: 'flex',
            WebkitBoxAlign: 'center',
            MsFlexAlign: 'center',
            alignItems: 'center',
            WebkitBoxPack: 'center',
            MsFlexPack: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            backgroundColor: colors.BLUE_LIGHT,
            lineHeight: 1,
            position: 'relative',
        },
    })
};
